import React from 'react';
import { cn } from '@/utils/cn';

const StarterItemSkeleton = ({ reverse = false }: { reverse?: boolean }) => {
  return (
    <li className={cn('flex items-center gap-1', reverse ? 'flex-row-reverse' : '')}>
      <div className="h-2 sm:h-3 w-4 sm:w-5 dark:bg-gray-600 bg-gray-200 rounded animate-pulse" />
      <div className="w-[7px] h-[7px] sm:w-[10px] sm:h-[10px] dark:bg-gray-600 bg-gray-200 rounded-full animate-pulse" />
      <div className="h-2 sm:h-3 w-16 sm:w-20 dark:bg-gray-600 bg-gray-200 rounded animate-pulse" />
    </li>
  );
};

const StartersSkeleton = () => {
  return (
    <div className="mt-4">
      <div className="h-3 sm:h-4 w-24 sm:w-32 dark:bg-gray-600 bg-gray-200 rounded animate-pulse mb-2.5" />
      <div className="flex justify-between">
        <ul className="pl-0 list-none space-y-2 sm:space-y-2.5">
          {Array.from({ length: 11 }).map((_, index) => (
            <StarterItemSkeleton key={`home-${index}`} />
          ))}
        </ul>
        <ul className="pl-0 list-none space-y-2 sm:space-y-2.5">
          {Array.from({ length: 11 }).map((_, index) => (
            <StarterItemSkeleton key={`away-${index}`} reverse />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default StartersSkeleton;
